<template>
  <v-card-text v-if="etablissement">
    <v-row justify="space-between">
      <v-col cols="12" md="3" lg="3">
        <span class="text-h6" style="color: black">Organisation</span>
        <s-text-info v-model="etablissement.raisonSociale" label="Raison sociale" required />
        <s-text-info v-model="etablissement.numeroFINESS" label="Numéro FINESS" required />
        <s-text-info v-model="etablissement.numeroSIRET" label="Numéro SIRET" required />
      </v-col>
      <v-col cols="12" md="4" lg="4">
        <span class="text-h6" style="color: black">Personnel</span>
        <etablissement-designer-directeur :etablissement="etablissement" />
        <etablissement-designer-comptables :etablissement="etablissement" />
      </v-col>
      <v-col cols="12" md="4" lg="4">
        <span class="text-h6 t-10" style="color: black">Dispositifs</span>
        <etablissement-dispositifs :etablissement="etablissement" />
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { mapGetters } from 'vuex'
import STextInfo from '@/components/global/s-text-info.vue'
import EtablissementDesignerDirecteur from '@/components/etablissement/administration/etablissement-designer-directeur.vue'
import EtablissementDesignerComptables from '@/components/etablissement/administration/etablissement-designer-comptables.vue'
import EtablissementDispositifs from '@/components/etablissement/administration/etablissement-dispositifs.vue'

export default {
  name: 'etablissement-detail-administration',
  components: {
    EtablissementDispositifs,
    EtablissementDesignerComptables,
    EtablissementDesignerDirecteur,
    STextInfo,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      etablissement: undefined,
    }
  },
  computed: {
    ...mapGetters({
      isInRole: 'security/isInRole',
    }),
  },
  created() {
    this.etablissement = this.value
  },
  watch: {
    value() {
      this.etablissement = this.value
    },
    etablissement: {
      handler() {
        this.$emit('input', this.etablissement)
      },
      deep: true,
    },
  },
}
</script>
